import React from 'react';
import { useArticleAuthorDialog } from '@/contexts/ArticleAuthorContext';
import { ArticleAuthorDialog } from './ArticleAuthorDialog';

export function GlobalArticleAuthorDialog() {
  const { isOpen, editingAuthor, brandId, closeAuthorDialog } = useArticleAuthorDialog();

  if (!brandId) return null;

  return (
    <ArticleAuthorDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeAuthorDialog();
      }}
      author={editingAuthor}
      brandId={brandId}
    />
  );
}
